import {useAtom} from 'jotai';
import {SidePanelSortBar} from '@/components/SidePanel/StyledComponents';
import {kodataStoresSortAtom} from '@/map/atom';
import {KodataStoresFilterTypes} from '@/map/enums';
import {FlexFullGrow} from '@/styled-components';
import {SortMenu} from '../SortMenu';

const SORT = [
  {
    columnName: KodataStoresFilterTypes.est3AverageSales,
    ascending: false,
    sort: `${KodataStoresFilterTypes.est3AverageSales.toUpperCase()}_DESC`,
    name: '매출 높은순(3개월)',
  },
  {
    columnName: KodataStoresFilterTypes.est3AverageSales,
    ascending: true,
    sort: `${KodataStoresFilterTypes.est3AverageSales.toUpperCase()}_ASC`,
    name: '매출 낮은순(3개월)',
  },
];

export const SortBar = ({disabled}: {disabled?: boolean}) => {
  const [sortInfo, setSortInfo] = useAtom(kodataStoresSortAtom);

  const currentSort = sortInfo
    ? SORT.find(
        (i) =>
          i.columnName === sortInfo.columnName &&
          i.ascending === sortInfo.ascending
      )
    : SORT[0];

  const onChange = (nextSortStr: string) => {
    setSortInfo((p) => {
      const prev = p ?? {
        ...currentSort,
      };

      const nextSort = SORT.find((i) => nextSortStr === i.sort);

      if (
        !nextSort ||
        (prev.columnName === nextSort.columnName &&
          prev.ascending === nextSort.ascending)
      ) {
        return prev;
      }

      return {
        columnName: nextSort.columnName,
        ascending: nextSort.ascending,
        sort: nextSort.sort,
      };
    });
  };

  return (
    <SidePanelSortBar>
      <FlexFullGrow />
      <SortMenu
        disabled={disabled}
        defaultSort={currentSort}
        options={SORT}
        onChange={onChange}
      />
    </SidePanelSortBar>
  );
};
